import React from 'react'
import { connect } from 'react-redux'

import { Row, Col, Form, Tab, Tabs } from 'react-bootstrap'

import { ArrowRightShort } from 'react-bootstrap-icons'

import {
  handleInfectionCourseFieldChange,
  addInfectionCourse,
  updatePrimaryInfectionSite,
  updatePathogen,
  addSusceptibilityTest,
  submitChartPrimaryInfectionSiteInfo,
  deletePrimarySiteFromServer,
  deletePathogenFromServer,
  submitChartPathogenInfo,
  submitChartSusceptibilityTestInfo,
  deleteSusceptibilityTestFromServer,
  updateAccordionActiveKey,
  addingNewSusceptibilityTest,
  generateNewPathogen,
} from '../reducers/infectionCourseFormReducer'

import { handleChartFieldChange } from '../reducers/chartFormReducer'
import FormInput from '../../../components/FormInput'
import CheckboxesWithOptionalTextField from '../../../components/CheckboxesWithOptionalTextField'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import InfectionCourseTabs from './InfectionCourseTabs'
import PrimaryInfectionSiteOptions from './PrimaryInfectionSiteOptions'


const InfectionCourseForm = (props) => {

  const handleDateChange = (date, fieldName) => {
    props.handleInfectionCourseFieldChange(fieldName, date)
    props.handleChartFieldChange('chartDateErrorMessage', '')
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const infectionCourse = { ...props, [fieldName]: date, 'chartDateErrorMessage': fieldName }
      return props.addInfectionCourse(infectionCourse)
    }
  }

  const handleSelect = (name, selected) => {
    return props.handleInfectionCourseFieldChange(name, selected)
  }

  const handlePathogenSelect = (name, selected, primarySite, pathogenId, pathogenDescription) => {
    //handles adding and removing pathogens from reducer state. If selected === true, add in pathogen. If selected === false, remove pathogen.
    if (selected) {
      const newPathogen = generateNewPathogen(name, primarySite, pathogenDescription)
      const payload = {primarySite: primarySite, name: 'pathogens', selection: [...primarySite.pathogens, newPathogen]}
      props.updatePrimaryInfectionSite(payload, props.primary_infection_sites)

      const pathogenInfo = {primaryInfectionSite: primarySite, pathogen: newPathogen, 'chartDateErrorMessage': name}
      return props.submitChartPathogenInfo(props, pathogenInfo)
    } else {
      let pathogenToRemove = primarySite.pathogens.find(pathogen => {
        if (pathogenId && pathogen.id) {
          return pathogen.id === pathogenId
        } else {
          return pathogen.name.toLowerCase() === name.toLowerCase()
        }
      })

      let removedPathogen = primarySite.pathogens.filter(pathogen => pathogen !== pathogenToRemove)
      const updatedInfectionSites = props.primary_infection_sites.map(site => {
        if (site === primarySite) {
          site.pathogens = removedPathogen
          return site
        } else {
          return site
        }
      })
      props.handleInfectionCourseFieldChange('primary_infection_sites', updatedInfectionSites)
      return props.deletePathogenFromServer(pathogenToRemove, props)
    }
  }

  const patchPathogen = (e, site, pathogen, fieldName) => {
    //optional fieldName prop makes this flexible for datepicker and checkbox component as well
    let name
    let value
    if (e && e.target) {
      name = e.target.name
      value = e.target.value
    } else {
      name = fieldName
      value = e
    }

    props.updatePathogen(props.primary_infection_sites, site, pathogen, name, value)

    if ((value instanceof Date && !isNaN(value)) || value === null) {
      props.handleChartFieldChange('chartDateErrorMessage', '')
      let updatedPathogen = {...pathogen, [name]: value}
      let pathogenInfo = {primaryInfectionSite: site, pathogen: updatedPathogen, key: fieldName, value: value, 'chartDateErrorMessage': name}
      return props.submitChartPathogenInfo(props, pathogenInfo)
    }
  }

  const checkboxPatchPathogen = (e, site, pathogen, fieldName) => {
    //optional fieldName prop makes this flexible for datepicker and checkbox component as well
    let name
    let value
    if (e.target) {
      name = e.target.name
      value = e.target.value
    } else {
      name = fieldName
      value = e
    }
    props.updatePathogen(props.primary_infection_sites, site, pathogen, name, value)

    const updatedPathogen = {...pathogen, [name]: value }
    const pathogenInfo = {primaryInfectionSite: site, pathogen: updatedPathogen, key: name, value: value, 'chartDateErrorMessage': name}
    return props.submitChartPathogenInfo(props, pathogenInfo)
  }

  const handlePrimarySiteSelect = (name, selected, infectionSite, primarySiteDescription) => {
    //handles adding and removing infection sites from reducer state. If selected === true, add in primary site. If selected === false, remove primary site.
    if (selected) {
      return props.addInfectionCourse(props, name, primarySiteDescription)
    } else {
      let primarySiteToDelete

      if (infectionSite) {
        primarySiteToDelete = infectionSite
      } else {
        primarySiteToDelete = props.primary_infection_sites.find(site => site.infection_site === name)
      }

      if (props.primary_infection_sites.length - 1 < 2) {
        // if there is one or less primary site, the following fields are reset to empty and the forms for them are hidden
        props.handleInfectionCourseFieldChange('confirmed_or_presumed_primary_source', '')
        props.handleInfectionCourseFieldChange('primary_source_infection_details', '')
        props.handleInfectionCourseFieldChange('confirmed_or_presumed_primary_source_description', '')
      }

      if (primarySiteToDelete.url) {
        return props.deletePrimarySiteFromServer(primarySiteToDelete.url, props)
      }
    }
  }

  const handlePrimarySiteNestedFieldsChange = (e, option) => {
    //because of nested nature of primaryInfectionSites, this function finds the correct primaryInfectionSite in props, structures data accordindly and dispatches data to change state
    const { name, value } = e.target
    let primarySiteName
    if (option.displayName) {
      primarySiteName = option.displayName
    } else {
      primarySiteName = option
    }
    let foundPrimarySite = props.primary_infection_sites.find(site => {
      if (option.id) {
        return site.id === option.id
      } else {
        return site.infection_site === primarySiteName
      }
    })

    const payload = {primarySite: foundPrimarySite, name: name, selection: value}
    return props.updatePrimaryInfectionSite(payload, props.primary_infection_sites)
  }

  const handleCultureSampleChange = (e, primarySite) => {
    const { name, value } = e.target
    const payload = {primarySite: primarySite, name: name, selection: value}
    if (value.toLowerCase() !== 'yes' || value !== '') {
      primarySite.pathogens.forEach(pathogen => {
        return props.deletePathogenFromServer(pathogen, props)
      })
      primarySite[`${name}`] = value
      primarySite['pathogens'] = []
      primarySite['displayPathogenQuestions'] = false
      props.updatePrimaryInfectionSite(payload, props.primary_infection_sites)
      return props.submitChartPrimaryInfectionSiteInfo(props, primarySite)
    } else {
      // props.toggleScreeningFailure(props, false)
      return props.updatePrimaryInfectionSite(payload, props.primary_infection_sites)
    }
  }

  const savePrimarySites = () => {
    if (props.primary_infection_sites.length > 0) {
      return props.handleInfectionCourseFieldChange('displayTabs', true)
    } else {
      //add error handling here if no primary sites are selected
      return props.handleInfectionCourseFieldChange('displayTabs', false)
    }
  }

  const savePathogens = (site) => {
    if (site.pathogens.length > 0) {
      const payload = {primarySite: site, name: 'displayPathogenQuestions', selection: !site.displayPathogenQuestions}
      return props.updatePrimaryInfectionSite(payload, props.primary_infection_sites)
    }
  }

  const addNewSusceptibilityTest = (site, pathogen, drugName) => {
    props.addingNewSusceptibilityTest()
    const newSusceptibilityTest = {
      id: pathogen.susceptibility_tests.find(test => test.id === pathogen.susceptibility_tests.length + 1) ? pathogen.susceptibility_tests.length + 2 : pathogen.susceptibility_tests.length + 1,
      pathogen: pathogen.url,
      drug_name: drugName,
      susceptibile: false,
      intermediate: false,
      resistant: false,
      not_interpretable: false,
      mic: '',
      zone: '',
      clsi: false,
      fda: false,
      eu_cast: false,
      test_not_done: false,
    }
    return props.submitChartSusceptibilityTestInfo(props, newSusceptibilityTest, pathogen)
  }

  const removeSusceptibilityTests = (e, pathogen, site) => {
    let name

    if (e.target) {
      name = e.target
    } else {
      name = e
    }
    pathogen.susceptibility_tests.forEach(test => {
      return props.deleteSusceptibilityTestFromServer(test, props)
    })
    return props.updatePathogen( props.primary_infection_sites, site, pathogen, name, [])
  }

  const hideTabs = () => {
    return props.handleInfectionCourseFieldChange('displayTabs', false)
  }

  const getValue = (option, fieldName) => {
    //because of nested nature of primaryInfectionSites, this function returns the value of the input
    const existingPrimarySite = props.primary_infection_sites.find(site => {
      if (option.id) {
        return site.id === option.id
      } else {
        return site.infection_site === option.displayName
      }
    })
    let nestedName
    if (fieldName) {
      nestedName = fieldName
    } else {
      nestedName = option.nestedName
    }
    return existingPrimarySite[`${nestedName}`]
  }

  const getRequired = (options) => {
    if (options.length !== 0) {
      let required = true
      if (props.primary_infection_sites.length !== 0) {
        required = false
      }
      return required
    } else {
      return null
    }
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let name = chartDateErrorMessage.split('[')[1].split(']')[0]
        if (key === name || name.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }


  const handleInfectionCourseBlur = () => {
    return props.addInfectionCourse(props)
  }

  const handlePrimarySitesBlur = (primarySite) => {
    return props.submitChartPrimaryInfectionSiteInfo(props, primarySite)
  }

  const handlePathogenBlur = (primaryInfectionSite, pathogen) => {
    const pathogenInfo = { primaryInfectionSite, pathogen, 'chartDateErrorMessage': pathogen.name }
    return props.submitChartPathogenInfo(props, pathogenInfo)
    // return props.submitChartPathogenInfo(props, null, 'input')
  }

  const handleSusceptibilityTestBlur = (susceptibilityTest, pathogen) => {
    return props.submitChartSusceptibilityTestInfo(props, susceptibilityTest, pathogen)
  }

  const changeAccordionActiveKey = (e) => {
    return props.updateAccordionActiveKey('accordionActiveKey', e)
  }

  const {
    date_of_onset,
    primary_infection_sites,
    displayTabs,
    chartForReview,
    accordionActiveKey,
    savingChartPhase,
    chartDateErrorMessage
  } = props

  const yesNoDontKnowOptions = [
    { value: "Yes" },
    { value: "No" },
    { value: "Not Applicable" },
    { value: "Don't Know" },
  ]


  const howWasInfectionDiagnosedOptions = [
    {
      displayName: 'Positive Bacterial Culture Results',
      fieldName: 'positive_bacterial_culture_results',
    },
    {
      displayName: 'Fever',
      fieldName: 'fever',
    },
    {
      displayName: 'Elevated Inflammatory Markers (WCC & CRP)',
      fieldName: 'elevated_inflammatory_markers',
    },
    {
      displayName: 'Other',
      fieldName: 'other_infection_diagnosed',
      textFields: [
        {
          displayName: 'Please Specify',
          fieldName: 'other_infection_diagnosed_description',
        },
      ]
    },
  ]

  const howWasInfectionDiagnosedOptionsRequred = (
    props.positive_bacterial_culture_results === false &&
    props.fever === false &&
    props.elevated_inflammatory_markers === false &&
    props.other_infection_diagnosed === false
  )


  const generatePrimarySourceOfInfectionOptions = () => {
    const primarySourceOptions = primary_infection_sites.map(site => {
      if (site.infection_site.toLowerCase() === 'other') {
        return { value: 'Other: ' + site.infection_site_description }
      } else if (site.infection_site.toLowerCase() === 'blood') {
        return {
          value: 'Blood',
          selectFields: [
            {
              displayName: "Where the primary infection site is a bloodstream infection, was the infection source thought to be venous line related?",
              fieldName: 'primary_source_infection_details',
              options: yesNoDontKnowOptions,
            }
          ],
        }
      } else if (site.infection_site.toLowerCase() === 'respiratory') {
        return {
          value: 'Respiratory',
          selectFields: [
            {
              displayName: "Where the primary infection site is respiratory, was the infection a ventilator associated pneumonia? (a new pneumonia that develops after 48 hours of invasive ventilation; note that, by the time of VAP onset, patients may have already been extubated)",
              fieldName: 'primary_source_infection_details',
              options: yesNoDontKnowOptions,
            }
          ],
        }
      } else {
        return { value: site.infection_site }
      }
    })
    if (props.confirmed_or_presumed_primary_source) {
      if (!primarySourceOptions.find(option => option.value === props.confirmed_or_presumed_primary_source)) {
        primarySourceOptions.push({ value: props.confirmed_or_presumed_primary_source })
      }
    }
    return primarySourceOptions.filter(Boolean)
  }


  const handleConfirmedOrPresumedPrimarySourceChange = (e) => {
    if (e.target.name === 'confirmed_or_presumed_primary_source') {
      props.handleInfectionCourseFieldChange('primary_source_infection_details', '')
      props.handleInfectionCourseFieldChange('confirmed_or_presumed_primary_source_description', '')
    }
    props.handleInfectionCourseFieldChange(e.target.name, e.target.value)
  }

  const handleHowInfectionDiagnosedSelect = (name, value) => {
    props.handleInfectionCourseFieldChange(name, value)

    const updatedProps = {
      ...props,
      [name]: value,
    }

    if (name === 'other_infection_diagnosed') {
      props.handleInfectionCourseFieldChange('other_infection_diagnosed_description', '')
      updatedProps.other_infection_diagnosed_description = ''
    }

    props.addInfectionCourse(updatedProps)
  }

  return (
    <div id="InfectionCourseForm">
      <Form validated={props.chartIsIncompleteModalData.length !== 0 ? true : false}>
        <Row>
          <Col xs={12} sm={12} md={8} lg={8}>
            <Form.Group>
              <Form.Label>
                Regarding the Gram-negative bacterial infection (Primary GNBI) for which cefiderocol was prescribed (i.e., indicated Primary GNBI), please answer the following items:
              </Form.Label>
            </Form.Group>
          </Col>
        </Row>

        <div className="indented-row">
          <FormInput
            label={'Date when the indicated GNBI was suspected/diagnosed at or during the current hospitalization:'}
            name={'date_of_onset'}
            value={date_of_onset}
            type={'date'}
            placeholder={'Enter date of onset'}
            xs={12}
            sm={12}
            md={8}
            lg={8}
            onChange={(date) => handleDateChange(date, 'date_of_onset')}
            onBlur={handleInfectionCourseBlur}
            disabled={chartForReview}
            errorText={getHelperText('date_of_onset')}
            required={true}
            infoText="The date of the indicated GNBI refers to the diagnosis of the infection itself, and may not always correspond with the date of the indicated or index culture of the GNBI. The index or indicated culture can even precede the admission date. The primary site of infection may not have an actual culture result if the indicated GNBI culture was obtained from a secondary site and the primary site of infection was determined on clinical grounds. (please refer to reference material explaining GNBI culture from primary and secondary infection site)."
          />
        </div>

        <div className="indented-row">
          <CheckboxesWithOptionalTextField
            label='How was infection suspected/diagnosed (select all that apply)?'
            options={howWasInfectionDiagnosedOptions}
            handleTextChange={(e) => props.handleInfectionCourseFieldChange(e.target.name, e.target.value)}
            handleSelect={(name, value) => handleHowInfectionDiagnosedSelect(name, value)}
            onBlur={handleInfectionCourseBlur}
            disabled={chartForReview || savingChartPhase ? true : false}
            required={howWasInfectionDiagnosedOptionsRequred}
            {...props}
          />
        </div>

        <br/>

        <div className="indented-row">
          <Row style={{ paddingBottom: "0" }}>
            <Col xs={12} sm={12} md={8} lg={8}>
              <Form.Label>
                Infection site(s)
              </Form.Label>
              <Form.Text>
                {`Select all that apply, then click "Save Infection Sites" button. To delete an infection site, simply uncheck the box next to it.`}
              </Form.Text>
              <Form.Text style={{marginBottom: '15px'}}>
                {`If you need to enter an infection site that is not in the list below, click the "Add Other Infection Site" button and enter the infection site's name when prompted.`}
              </Form.Text>
            </Col>
          </Row>
          <PrimaryInfectionSiteOptions 
            primary_infection_sites={props.primary_infection_sites}
            disabled={displayTabs || chartForReview || savingChartPhase ? true : false}
            nestedFieldDisabled={displayTabs || chartForReview ? true : false}
            handlePrimarySiteSelect={handlePrimarySiteSelect}
            getRequired={getRequired}
            getValue={getValue}
            handlePrimarySiteNestedFieldsChange={handlePrimarySiteNestedFieldsChange}
            handlePrimarySitesBlur={handlePrimarySitesBlur}
            displayTabs={displayTabs}
            chartForReview={chartForReview}
            hideTabs={hideTabs}
            savePrimarySites={savePrimarySites}
          />
        </div>
        
        <br/>

        {Array.isArray(props.primary_infection_sites) && props.primary_infection_sites.length > 1 ?
          <div className="indented-row">
            <br />
            <SelectWithOptionalTextField
              label='Where multiple infection sites have been ticked, please indicate the confirmed/presumed primary source of infection:'
              options={generatePrimarySourceOfInfectionOptions()}
              selected={props.confirmed_or_presumed_primary_source}
              selectFieldName='confirmed_or_presumed_primary_source'
              handleChange={handleConfirmedOrPresumedPrimarySourceChange}
              onBlur={handleInfectionCourseBlur}
              disabled={chartForReview}
              placeholder="Please make a selection"
              required={true}
              infoText={
                <p>
                  <span>
                    In situations such as osteomyelitis, where there may be an infection that affects multiple contiguous structures, (i.e., skin
                  </span>
                  {' '}
                  <span>
                    <ArrowRightShort />
                  </span>
                  {' '}
                  <span>
                    fascia
                  </span>
                  {' '}
                  <span>
                    <ArrowRightShort />
                  </span>
                  {' '}
                  <span>
                    muscle/bone), even though the index or indicated GNBI culture was obtained from a more superficial structure such as the skin, the primary site should still be the deepest or most serious structure affected as long as there was evidence supporting that depth of infection. Do not consider the superficial structure and the deeper structure 2 different sites of infection.
                  </span>

                </p>
              }
              {...props}
            />
          </div>
          :
          null
        }

        <br />

        <div className="indented-row">
          <SelectWithOptionalTextField
            label='If the primary source of infection is related to an infected prosthetic or indwelling catheter (e.g. urinary or venous catheter), was the source removed?'
            options={yesNoDontKnowOptions}
            selected={props.primary_source_related_to_prosthetic}
            selectFieldName='primary_source_related_to_prosthetic'
            handleChange={(e) => {
              props.handleInfectionCourseFieldChange('primary_source_related_to_prosthetic', e.target.value)
              props.handleInfectionCourseFieldChange('device_removed_or_replaced_date', null)
            }}
            onBlur={handleInfectionCourseBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          {props.primary_source_related_to_prosthetic.toLowerCase() === 'yes' ?
            <div className="indented-row">
              <FormInput
                label="What was the date?"
                type='date'
                value={props.device_removed_or_replaced_date}
                required={true}
                onChange={(date) => handleDateChange(date, 'device_removed_or_replaced_date')}
                onBlur={handleInfectionCourseBlur}
                disabled={chartForReview}
                errorText={getHelperText('device_removed_or_replaced_date')}
              />
            </div>
            :
            null
          }
        </div>

        <br />

        <div className="indented-row">
          <SelectWithOptionalTextField
            label='If the primary source of infection was related to some other source other than above (e.g. empyema, diverticulitis, other), was this addressed?'
            options={yesNoDontKnowOptions}
            selected={props.primary_source_addressed}
            selectFieldName='primary_source_addressed'
            handleChange={(e) => {
              props.handleInfectionCourseFieldChange('primary_source_addressed', e.target.value)
              props.handleInfectionCourseFieldChange('primary_source_addressed_date', null)
            }}
            onBlur={handleInfectionCourseBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          {props.primary_source_addressed.toLowerCase() === 'yes' ?
            <div className="indented-row">
              <FormInput
                label="What was the date?"
                type='date'
                value={props.primary_source_addressed_date}
                required={true}
                onChange={(date) => handleDateChange(date, 'primary_source_addressed_date')}
                onBlur={handleInfectionCourseBlur}
                disabled={chartForReview}
                errorText={getHelperText('primary_source_addressed_date')}
              />
            </div>
            :
            null
          }
        </div>

        <br/>
        <br/>

        {
          displayTabs
          ?
          <div className="indented-row">
            <p>
              Please answer the following questions in each tab for every infection site selected
            </p>
            <Tabs defaultActiveKey={primary_infection_sites[0].id}>
              {primary_infection_sites.map(site => {
                let title = site.infection_site
                if (title.toLowerCase() === 'other') {
                  title += `: ${site.infection_site_description}`
                }
                return (
                  <Tab
                    key={site.id}
                    eventKey={site.id}
                    title={title}
                  >
                    <InfectionCourseTabs
                      site={site}
                      handleCultureSampleChange={handleCultureSampleChange}
                      handleSelect={handleSelect}
                      handlePathogenSelect={handlePathogenSelect}
                      chartForReview={chartForReview}
                      savePathogens={savePathogens}
                      patchPathogen={patchPathogen}
                      checkboxPatchPathogen={checkboxPatchPathogen}
                      addNewSusceptibilityTest={addNewSusceptibilityTest}
                      removeSusceptibilityTests={removeSusceptibilityTests}
                      handlePathogenBlur={handlePathogenBlur}
                      handleSusceptibilityTestBlur={handleSusceptibilityTestBlur}
                      accordionActiveKey={accordionActiveKey}
                      changeAccordionActiveKey={changeAccordionActiveKey}
                      savingChartPhase={savingChartPhase}
                      {...props}
                    />
                  </Tab>
                )
              })
              }
            </Tabs>
          </div>
          :
          null
        }

        
      </Form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    infection_course_info_url: state.infectionCourseFormReducer.infection_course_info_url,
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    savingChartPhase: state.chartFormReducer.savingChartPhase,
    patient_chart_id: state.infectionCourseFormReducer.patient_chart_id,
    date_of_onset: state.infectionCourseFormReducer.date_of_onset,

    positive_bacterial_culture_results: state.infectionCourseFormReducer.positive_bacterial_culture_results,
    fever: state.infectionCourseFormReducer.fever,
    elevated_inflammatory_markers: state.infectionCourseFormReducer.elevated_inflammatory_markers,
    other_infection_diagnosed: state.infectionCourseFormReducer.other_infection_diagnosed,
    other_infection_diagnosed_description: state.infectionCourseFormReducer.other_infection_diagnosed_description,

    confirmed_or_presumed_primary_source: state.infectionCourseFormReducer.confirmed_or_presumed_primary_source,
    confirmed_or_presumed_primary_source_description: state.infectionCourseFormReducer.confirmed_or_presumed_primary_source_description,
    primary_source_related_to_prosthetic: state.infectionCourseFormReducer.primary_source_related_to_prosthetic,
    primary_source_addressed: state.infectionCourseFormReducer.primary_source_addressed,
    primary_source_infection_details: state.infectionCourseFormReducer.primary_source_infection_details,
    device_removed_or_replaced_date: state.infectionCourseFormReducer.device_removed_or_replaced_date,
    primary_source_addressed_date: state.infectionCourseFormReducer.primary_source_addressed_date,

    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    currentUser: state.loginReducer.currentUser,

    admissionDate: state.hospitalAdmissionFormReducer.admissionDate,

    //primaryInfectionSite Bools
    primary_infection_sites: state.infectionCourseFormReducer.primary_infection_sites,
    displayTabs: state.infectionCourseFormReducer.displayTabs,
    accordionActiveKey: state.infectionCourseFormReducer.accordionActiveKey,

    cultureSampleTakenPathogenIdentified: state.infectionCourseFormReducer.cultureSampleTakenPathogenIdentified,

  }
}

const mapDispatchToProps = {
  handleInfectionCourseFieldChange,
  addInfectionCourse,
  updatePrimaryInfectionSite,
  updatePathogen,
  addSusceptibilityTest,
  submitChartPrimaryInfectionSiteInfo,
  deletePrimarySiteFromServer,
  deletePathogenFromServer,
  deleteSusceptibilityTestFromServer,
  submitChartPathogenInfo,
  submitChartSusceptibilityTestInfo,
  updateAccordionActiveKey,
  handleChartFieldChange,
  addingNewSusceptibilityTest,
}

export default connect(mapStateToProps, mapDispatchToProps)(InfectionCourseForm)
